export enum EnumStatus {
  Success     = 200,
  Unauthorize = 401,
  Forbidden   = 403,
  Error       = 500,
  ErrorSystem = 505,
}

export enum EnumHttp {
  Get,
  Put,
  Post,
  Delete,
  GetAuth,
  PutAuth,
  PostAuth,
  DeleteAuth
}

export enum EnumPermission {
  // const ADMIN_VIEW                            = "4415297e3af8c",
  OPERATION_LOG_VIEW                    = "OPERATION_LOG_VIEW",
  DOWNLOAD_LOG_VIEW                     = "DOWNLOAD_LOG_VIEW",

  ADMIN_VIEW                            = "ADMIN_VIEW",
  ADMIN_ADD                             = "ADMIN_ADD",
  ADMIN_EDIT                            = "ADMIN_EDIT",
  ADMIN_DELETE                          = "ADMIN_DELETE",
  ADMIN_EDIT_PASSWORD                   = "ADMIN_EDIT_PASSWORD",
  ADMIN_EDIT_AUTHORITY                  = "ADMIN_EDIT_AUTHORITY",

  ADMIN_AUTHORITY_VIEW                  = "ADMIN_AUTHORITY_VIEW",
  ADMIN_AUTHORITY_ADD                   = "ADMIN_AUTHORITY_ADD",
  ADMIN_AUTHORITY_EDIT                  = "ADMIN_AUTHORITY_EDIT",
  ADMIN_AUTHORITY_DELETE                = "ADMIN_AUTHORITY_DELETE",
    
  ANNOUNCEMENT_VIEW                     = "ANNOUNCEMENT_VIEW",
  ANNOUNCEMENT_ADD                      = "ANNOUNCEMENT_ADD",
  ANNOUNCEMENT_EDIT                     = "ANNOUNCEMENT_EDIT",
  ANNOUNCEMENT_DELETE                   = "ANNOUNCEMENT_DELETE",

  AGENT_VIEW                            = "AGENT_VIEW",
  AGENT_ADD                             = "AGENT_ADD",
  AGENT_EDIT                            = "AGENT_EDIT",
  // AGENT_DELETE                          = "AGENT_DELETE",
  AGENT_EDIT_PASSWORD                   = "AGENT_EDIT_PASSWORD",
  // AGENT_EXPORT                          = "AGENT_EXPORT",
  
  TASK_FORM_VIEW                        = "TASK_FORM_VIEW",
  TASK_FORM_ADD                         = "TASK_FORM_ADD",
  TASK_FORM_MATCH                       = "TASK_FORM_MATCH",
  TASK_FORM_DELETE                      = "TASK_FORM_DELETE",

  TASK_VIEW                             = "TASK_VIEW",
  BATCH_VIEW                            = "BATCH_VIEW",
  BATCH_EDIT                            = "BATCH_EDIT",
    
  REPORT_DCA_VIEW                       = "REPORT_DCA_VIEW",
  REPORT_SUMMARY_DCA_VIEW               = "REPORT_SUMMARY_DCA_VIEW",
  REPORT_SUMMARY_BATCH_VIEW             = "REPORT_SUMMARY_BATCH_VIEW"
}

export enum EnumUserType {
  SYSTEM,
  ADMIN,
  AGENT
}

export enum EnumLogActionType {
  LOGIN,
  CREATE,
  UPDATE,
  DELETE
}

export enum EnumDownloadLogActionType {
  SINGLE,
  MULTI
}


export enum EnumStatusTaskForm {
  FAILED                = -4,
  PROCESSING_DELETION   = -3,
  PROCESSING_REMATCHING = -2,
  DELETED               = -1,
  NEW                   = 0,
  PENDING_REMATCHION    = 1,
  SUCCESS               = 2
}